import { render, staticRenderFns } from "./EditPaChief.vue?vue&type=template&id=7155bdf2&scoped=true"
import script from "./EditPaChief.vue?vue&type=script&lang=js"
export * from "./EditPaChief.vue?vue&type=script&lang=js"
import style0 from "./EditPaChief.vue?vue&type=style&index=0&id=7155bdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155bdf2",
  null
  
)

export default component.exports